import React from 'react';
import { Alert, Button, Spinner } from 'react-bootstrap';

export function HistoryControls({ history, label = 'history' }) {
  if (history.error) return <Alert variant="danger">Failed to load {label}: {history.error} <Button size="sm" onClick={history.reload}>Retry {label}</Button></Alert>;
  return <div className="d-flex align-items-center gap-2 my-2" aria-label={`${label} pagination`}>
    {history.loading && <Spinner animation="border" size="sm" />}
    <Button size="sm" variant="outline-secondary" disabled={history.loading || history.page === 0} onClick={history.previous}>Previous {label}</Button>
    <span className="small">Page {history.page + 1}{history.total !== undefined ? ` · ${history.total} records` : ''}</span>
    <Button size="sm" variant="outline-secondary" disabled={history.loading || !history.hasNext} onClick={history.next}>Next {label}</Button>
  </div>;
}
